import React, { PropTypes, Component } from 'react';
import { NitroDivider, NitroIcon, NitroLoading } from 'nitro-components';
import styled from 'styled-components';

import PortalNotification from './PortalNotification';
import EmailNotification from './EmailNotification';

import { media } from 'style-utils';

import Breakpoint from '../../../../utils/breakpoints';

const MainContainer = styled.div`
	display: flex;
`;

const SettingsMenu = styled.ul`
	min-width: 25%;
	list-style-type: none;
	padding: 0px;
	${media.mobileTablet`
        width: 100%;
    `}
`;

const SettingMenuItem = styled.li`
	a {
		text-decoration: none;
		font-size: ${props => props.theme.size[3]};
		font-family: ${props => props.theme.font.bold};
		cursor: pointer;
		color: ${props => (props.activePanel ? props.theme.color.secondary : props.theme.color.base3)};
		${media.mobileTablet`
	       color: ${props => props.theme.color.secondary}
    	`}

	}

	span {
		display: none;
		${media.mobileTablet`
	       display: inline-block;
	       float: right;
    	`}
	}
`;

const SettingsContainer = styled.section`
	min-width: 70%;
	margin-left: 5%;
	${media.mobileTablet`
        display: none;
    `}
`;

const NoticationContentMobile = styled.div`
	background: #f7f7f7;
`;

const MobileComponent = styled.div`
        width: 100%;
`;

class SettingsPanel extends Component {
	constructor(props) {
		super(props);
	}

	goToSettings = (componentType, index) => {
		this.props.onOptionChange(componentType, index);
	};

	render() {
		const {
			details,
			data,
			saveInfo,
			activePanel,
			fetchingSettings,
			selectedComponent
		} = this.props;
		let NotificationSettingsComponent;
		const componentType = selectedComponent.component;
		switch (componentType) {
			case 'PortalNotification':
				NotificationSettingsComponent = PortalNotification;
				break;
			case 'EmailNotification':
				NotificationSettingsComponent = EmailNotification;
				break;
			default:
				NotificationSettingsComponent = PortalNotification;
				break;
		}
		return (
			<div>
				<Breakpoint name="mobileTablet">
					<MainContainer>
						{activePanel < 0 &&
							<SettingsMenu>
								{details.map((item, index) => {
									return (
										<SettingMenuItem
											key={`mobile-setting-${index}`}
											onClick={() =>
												this.goToSettings(
													item.component,
													index
												)}
											activePanel={activePanel === index}
										>
											<a>{item.title}</a>
											<NitroIcon
												name="arrow-right"
												variant="base3"
												size="8"
											/>
											{' '}
											<NitroDivider />
										</SettingMenuItem>
									);
								})}
							</SettingsMenu>}
						{activePanel >= 0 &&
							<MobileComponent>
								<NoticationContentMobile>
									<NotificationSettingsComponent
										data={data}
										saveInfo={saveInfo}
									/>
								</NoticationContentMobile>
							</MobileComponent>}
					</MainContainer>
				</Breakpoint>
				<Breakpoint name="desktop">

					<MainContainer>
						<SettingsMenu>
							{details.map((item, index) => {
								return (
									<SettingMenuItem
										key={`desktop-setting-${index}`}
										onClick={() =>
											this.goToSettings(
												item.component,
												index
											)}
										activePanel={activePanel === index}
									>
										<a>{item.title}</a>

										<NitroDivider />
									</SettingMenuItem>
								);
							})}
						</SettingsMenu>
						<SettingsContainer>
							{this.props.activePanel >= 0 &&
								<NotificationSettingsComponent
									data={data}
									saveInfo={saveInfo}
								/>}
						</SettingsContainer>
					</MainContainer>
				</Breakpoint>

				{fetchingSettings &&
					<NitroLoading center thickness={2} size={24} />}
			</div>
		);
	}
}

SettingsPanel.propTypes = {
	data: PropTypes.array,
	details: PropTypes.array,
	saveInfo: PropTypes.func,
	activePanel: PropTypes.number,
	onOptionChange: PropTypes.func,
	setActivePanel: PropTypes.func,
	fetchingSettings: PropTypes.bool,
	selectedComponent: PropTypes.object
};

SettingsPanel.contextTypes = {
	router: PropTypes.object
};

SettingsPanel.defaultProps = {
	activePanel: -1
};

export default SettingsPanel;



// WEBPACK FOOTER //
// ./src/features/notification/notification-settings/components/SettingsPanel.js